/** Copyright (c) 2019 T.Rowe Price. All rights reserved. */

import './PhoneNumbers.scss';

import isEmpty from 'lodash/isEmpty';
import noop from 'lodash/noop';
import { array, func, object } from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';
import {
  CMMPhoneMapper,
  CMMPhoneNumberOrder
} from 'services/ContactMethodMaintenance';
import { ReactComponent as MobilePhoneQuestion } from 'assets/icons/mobile-phone-question-simple.svg';
import Content, { contentConverter } from 'services/Content';
import WithUserPermissions from 'components/shared/WithUserPermissions/WithUserPermissions';

const noPhoneNumberMessage = contentConverter.makeHtml(
  Content.noPhoneNumberCommunicationError
);

const PhoneNumber = ({ phoneNumber }) => {
  const { areaCode, countryCode, exchange, localNumber } = phoneNumber;

  return (
    <span className="cmm-modal-content-phone">
      {areaCode
        ? `(${areaCode}) ${exchange}-${localNumber}`
        : `${countryCode}-${exchange}${localNumber}`}
    </span>
  );
};

PhoneNumber.propTypes = {
  phoneNumber: object.isRequired
};

const PhoneNumberWithPermissions = WithUserPermissions(PhoneNumber);

const Numbers = ({ phoneNumbers = [] }) => (
  <div className="cmm-modal-content-header-container">
    <div className="cmm-modal-content-header">Phone Numbers</div>
    {CMMPhoneNumberOrder.map((typeId, index) => {
      const phoneNumber = phoneNumbers.find((phone) => phone.typeId === typeId);

      return (
        <div className="cmm-modal-content-header-details" key={index}>
          <span className="cmm-modal-content-phone-title">
            {CMMPhoneMapper[typeId]}
          </span>
          {phoneNumber ? (
            <PhoneNumberWithPermissions phoneNumber={phoneNumber} shouldMask />
          ) : (
            <Link
              className="cmm-modal-content-add-phone"
              to="/profile/contact-information"
              id="e2e-cmm-add-phone-number">
              Add phone number
            </Link>
          )}
        </div>
      );
    })}
  </div>
);

Numbers.propTypes = {
  phoneNumbers: array,
  onClick: func
};

Numbers.defaultProps = {
  phoneNumbers: [],
  onClick: noop
};

const NoNumbers = () => (
  <div className="cmm-modal-content-subgroup cmm-no-phone-numbers">
    <div className="cmm-modal-content-flex-container">
      <Numbers />
      <div className="cmm-modal-content-message">
        <div className="cmm-modal-no-numbers-image">
          <MobilePhoneQuestion />
        </div>
        <div dangerouslySetInnerHTML={{ __html: noPhoneNumberMessage }} />
      </div>
    </div>
  </div>
);

const PhoneNumbers = ({ phoneNumbers, onClick }) =>
  isEmpty(phoneNumbers) ? (
    <NoNumbers />
  ) : (
    <div className="cmm-modal-content-subgroup cmm-phone-numbers">
      <div className="cmm-modal-content-flex-container">
        <Numbers phoneNumbers={phoneNumbers} onClick={onClick} />
      </div>
    </div>
  );

PhoneNumbers.propTypes = {
  onClick: func
};

PhoneNumbers.defaultProps = {
  onClick: noop
};

export default PhoneNumbers;
